import { getLang, t } from './i18n.js';
import { Link } from './router.jsx';
import { Logo } from './ui.jsx';
import { COMPANY as COMPANY_INFO } from './company.jsx';

// ร่างข้อกำหนดและนโยบายความเป็นส่วนตัว เนื้อหาตรงกับการทำงานของระบบจริง
// ต้องให้ที่ปรึกษากฎหมายตรวจและกรอกชื่อนิติบุคคล ที่อยู่ และช่องทางติดต่อก่อนเปิดใช้งานจริง
const COMPANY = COMPANY_INFO.legalName || COMPANY_INFO.name;
const CONTACT = [COMPANY_INFO.email, COMPANY_INFO.phone, COMPANY_INFO.line && `LINE ${COMPANY_INFO.line}`].filter(Boolean).join(' · ') || t('ตามช่องทางที่หน้าศูนย์ช่วยเหลือ', 'through the channels on the Help centre page');
const UPDATED = t('3 ตุลาคม 2569', '3 October 2026');

const Page = ({ title, children }) => (
  <div className="page legal">
    <Logo className="welcome-logo" />
    <div><h1>{title}</h1><p className="muted small">{t('ปรับปรุงล่าสุด', 'Last updated')} {UPDATED}</p></div>
    <div className="note">{t('ฉบับร่าง: โครงสร้างและเนื้อหาตรงกับการทำงานของระบบ แต่ยังไม่ผ่านการตรวจของที่ปรึกษากฎหมาย', 'Draft: the structure and content match how the system works, but it has not been reviewed by a legal adviser. This English text is a translation for convenience; if the two differ, the Thai version applies.')}</div>
    {children}
    <p className="small"><Link to="/terms">{t('ข้อกำหนดการใช้งาน', 'Terms of Use')}</Link> {t('และ', 'and')} <Link to="/privacy">{t('นโยบายความเป็นส่วนตัว', 'Privacy Policy')}</Link></p>
  </div>
);
const S = ({ n, title, children }) => <section><h2>{n}. {title}</h2>{children}</section>;

/* th-only:start */
function TermsTh() {
  return (
    <Page title="ข้อกำหนดการใช้งาน">
      <S n={1} title="บทนำ">
        <p>{COMPANY} ให้บริการพื้นที่ลงประกาศขายและให้เช่าอสังหาริมทรัพย์ และช่องทางให้ผู้สนใจติดต่อผู้ลงประกาศ เราไม่ได้เป็นคู่สัญญา นายหน้า หรือตัวแทนในการซื้อขายหรือเช่าระหว่างผู้ใช้ การใช้บริการถือว่าคุณยอมรับข้อกำหนดนี้</p>
      </S>
      <S n={2} title="คุณสมบัติของผู้ใช้">
        <ul><li>คุณต้องบรรลุนิติภาวะตามกฎหมายไทย หรือได้รับความยินยอมจากผู้แทนโดยชอบธรรม</li>
          <li>ผู้ลงประกาศต้องเป็นเจ้าของทรัพย์ หรือได้รับมอบอำนาจจากเจ้าของ</li>
          <li>ผู้ที่เคยถูกยกเลิกบัญชีเพราะทำผิดข้อกำหนดไม่มีสิทธิ์สมัครใหม่</li></ul>
      </S>
      <S n={3} title="การสร้างบัญชี">
        <ul><li>หนึ่งคนใช้หนึ่งบัญชี ข้อมูลที่ใช้สมัครต้องเป็นของคุณเองและเป็นปัจจุบัน</li>
          <li>คุณต้องเก็บรหัสผ่านเป็นความลับ และรับผิดชอบการใช้งานที่เกิดจากบัญชีของคุณ</li>
          <li>บทบาท (เจ้าของ นายหน้า ผู้ซื้อ) เลือกตอนสมัครและเปลี่ยนภายหลังไม่ได้</li></ul>
      </S>
      <S n={4} title="การยืนยันอีเมลและ SMS">
        <ul><li>เราส่งรหัสใช้ครั้งเดียว 6 หลักไปที่อีเมลหรือเบอร์โทรของคุณเพื่อยืนยันตอนสมัคร เข้าสู่ระบบ และตั้งรหัสผ่านใหม่ รหัสใช้ได้ 5 นาที</li>
          <li>ห้ามบอกรหัสกับผู้อื่น ทีมงานจะไม่ขอรหัสจากคุณ</li>
          <li>เจ้าของและนายหน้าต้องยืนยันตัวตนด้วยเอกสารให้ผ่านก่อนเผยแพร่ประกาศแรก</li></ul>
      </S>
      <S n={5} title="ความรับผิดชอบต่อประกาศ">
        <ul><li>ข้อมูล ราคา และรูปภาพต้องถูกต้อง เป็นปัจจุบัน และเป็นรูปของทรัพย์นั้นจริง</li>
          <li>ทุกประกาศผ่านการตรวจของทีมงานก่อนออนไลน์ การอนุมัติไม่ใช่การรับรองความถูกต้องของข้อมูล</li>
          <li>ป้าย “ตรวจเอกสารสิทธิ์แล้ว” หมายความว่าทีมงานได้ตรวจเอกสารที่ผู้ลงประกาศส่งมา ไม่ใช่การรับรองกรรมสิทธิ์ ผู้ซื้อควรตรวจสอบกับกรมที่ดินก่อนทำสัญญา</li>
          <li>เมื่อขายหรือปล่อยเช่าแล้ว ผู้ลงประกาศต้องปิดประกาศ</li></ul>
      </S>
      <S n={6} title="การชำระเงินและการคืนเงิน">
        <ul><li>การลงประกาศพื้นฐานไม่มีค่าใช้จ่าย บริการที่มีค่าใช้จ่ายแสดงราคาเป็นเงินบาทก่อนยืนยันทุกครั้ง</li>
          <li>แพ็กเกจต่ออายุอัตโนมัติตามรอบที่เลือกจนกว่าจะยกเลิก เมื่อยกเลิก คุณใช้แพ็กเกจได้จนสิ้นรอบปัจจุบัน</li>
          <li>ค่าบริการที่ชำระแล้วไม่คืนเงิน เว้นแต่กฎหมายกำหนดไว้เป็นอย่างอื่น หรือเกิดจากความผิดพลาดของระบบ</li></ul>
      </S>
      <S n={7} title="เครดิตและแพ็กเกจสมาชิก">
        <ul><li>การเปลี่ยนแพ็กเกจกลางรอบเริ่มรอบใหม่ทันที และไม่คืนเงินรอบเดิม</li>
          <li>เมื่อลดแพ็กเกจ ประกาศที่เกินจำนวนของแพ็กเกจใหม่จะถูกหยุดชั่วคราว</li>
          <li>เครดิตไม่มีวันหมดอายุ ไม่สามารถแลกคืนเป็นเงินหรือโอนให้ผู้อื่น และค่าตรวจเอกสารสิทธิ์ไม่คืนเมื่อเอกสารไม่ผ่าน</li></ul>
      </S>
      <S n={8} title="เนื้อหาและการกระทำต้องห้าม">
        <ul><li>ประกาศซ้ำ ประกาศหลอกลวง ทรัพย์ที่ไม่มีอยู่จริง หรือทรัพย์ที่ขายหรือปล่อยเช่าไปแล้ว</li>
          <li>เนื้อหาที่ผิดกฎหมาย ละเมิดสิทธิ์ผู้อื่น ลามกอนาจาร หรือเลือกปฏิบัติ</li>
          <li>การส่งสแปม ข้อความคุกคาม หรือการนำข้อมูลติดต่อของผู้อื่นไปใช้นอกเหนือจากการสอบถามและเจรจาเกี่ยวกับประกาศ</li>
          <li>รีวิวที่ไม่ได้มาจากประสบการณ์จริง รีวิวที่แลกกับผลประโยชน์ หรือรีวิวที่มีคำหยาบหรือข้อมูลส่วนตัวของผู้อื่น</li>
          <li>การพยายามเข้าถึงระบบโดยไม่ได้รับอนุญาต หรือดึงข้อมูลจากเว็บด้วยโปรแกรมอัตโนมัติ</li></ul>
      </S>
      <S n={9} title="การระงับและการยกเลิกบัญชี">
        <ul><li>เราอาจปฏิเสธ หยุด หรือลบประกาศ ซ่อนรีวิว และระงับบัญชีที่ทำผิดข้อกำหนด โดยแจ้งเหตุผลให้ทราบ</li>
          <li>บัญชีที่ถูกระงับจะถูกออกจากระบบทุกอุปกรณ์ และประกาศจะไม่แสดงต่อสาธารณะ</li>
          <li>คุณขอยกเลิกบัญชีได้โดยติดต่อเรา ค่าบริการที่ชำระแล้วไม่คืนเมื่อบัญชีถูกระงับเพราะทำผิดข้อกำหนด</li></ul>
      </S>
      <S n={10} title="ข้อจำกัดความรับผิด">
        <p>เราไม่รับประกันความถูกต้องของประกาศและรีวิวที่ผู้ใช้ลง และไม่รับผิดต่อความเสียหายจากการทำธุรกรรมระหว่างผู้ใช้ กรุณาตรวจสอบทรัพย์ เอกสารสิทธิ์ และคู่สัญญาด้วยตนเองก่อนชำระเงินทุกครั้ง บริการให้ตามสภาพที่เป็นอยู่ และอาจหยุดชั่วคราวเพื่อปรับปรุง</p>
      </S>
      <S n={11} title="กฎหมายที่ใช้บังคับ">
        <p>ข้อกำหนดนี้อยู่ภายใต้กฎหมายไทย ข้อพิพาทอยู่ในเขตอำนาจของศาลไทย เราอาจปรับปรุงข้อกำหนดนี้และจะแจ้งในแอปก่อนมีผล ติดต่อเรา: {CONTACT}</p>
      </S>
    </Page>
  );
}

function PrivacyTh() {
  return (
    <Page title="นโยบายความเป็นส่วนตัว">
      <p>{COMPANY} เป็นผู้ควบคุมข้อมูลส่วนบุคคลตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562</p>
      <S n={1} title="ข้อมูลที่เราเก็บ">
        <ul><li>ข้อมูลบัญชี: ชื่อ อีเมล เบอร์โทรศัพท์ บทบาท และรหัสผ่านที่เข้ารหัสแบบทางเดียว</li>
          <li>เอกสารยืนยันตัวตนและเอกสารสิทธิ์ที่คุณส่งให้ตรวจ</li>
          <li>ประกาศ รูปภาพ ที่อยู่ทรัพย์ และข้อมูลติดต่อที่คุณใส่ในประกาศ</li>
          <li>ข้อความแชต คำขอนัดชม รีวิว ประกาศและการค้นหาที่บันทึก</li>
          <li>ประวัติแพ็กเกจและเครดิต เราไม่เก็บหมายเลขบัตรชำระเงิน</li>
          <li>ข้อมูลการใช้งานเพื่อความปลอดภัย: หมายเลข IP ประเภทเบราว์เซอร์ และบันทึกการทำรายการสำคัญ</li></ul>
      </S>
      <S n={2} title="เหตุผลที่เราเก็บ">
        <ul><li>เพื่อปฏิบัติตามสัญญาให้บริการ: สมัครสมาชิก ลงประกาศ ติดต่อระหว่างผู้ใช้ และชำระเงิน</li>
          <li>เพื่อประโยชน์โดยชอบด้วยกฎหมาย: ตรวจสอบประกาศ ป้องกันการหลอกลวง และรักษาความปลอดภัยของระบบ</li>
          <li>ตามความยินยอมของคุณ: การแจ้งเตือนทางอีเมล ซึ่งปิดได้ที่หน้าตั้งค่า</li></ul>
      </S>
      <S n={3} title="วิธีที่เราใช้ข้อมูล">
        <ul><li>ข้อมูลในประกาศแสดงต่อสาธารณะ เบอร์โทรศัพท์ LINE และอีเมลของผู้ลงประกาศแสดงต่อผู้ใช้ที่เข้าสู่ระบบ ตามแพ็กเกจของผู้ลงประกาศ</li>
          <li>เมื่อคุณฝากข้อความหรือขอนัดชม ผู้ลงประกาศจะเห็นชื่อและข้อความของคุณ และอาจเห็นเบอร์โทรศัพท์และอีเมล ตามแพ็กเกจของผู้ลงประกาศ</li>
          <li>รีวิวแสดงต่อสาธารณะพร้อมชื่อต้นของผู้เขียน</li>
          <li>เอกสารยืนยันตัวตนและเอกสารสิทธิ์เปิดดูได้เฉพาะทีมตรวจสอบ ผ่านลิงก์ที่มีอายุ 5 นาที</li>
          <li>เราไม่ขายข้อมูลส่วนบุคคล และไม่ใช้เพื่อโฆษณาของบุคคลที่สาม</li></ul>
      </S>
      <S n={4} title="ผู้ประมวลผลข้อมูลภายนอก">
        <ul><li>ผู้ให้บริการ SMS: รับเบอร์โทรศัพท์และข้อความรหัสยืนยัน</li>
          <li>ผู้ให้บริการอีเมล: รับอีเมล รหัสยืนยัน และเนื้อหาการแจ้งเตือน</li>
          <li>ผู้ให้บริการชำระเงิน: รับข้อมูลการชำระเงินโดยตรงจากคุณ เราได้รับเพียงผลการชำระและรหัสอ้างอิง</li>
          <li>ผู้ให้บริการเซิร์ฟเวอร์และที่เก็บไฟล์: เก็บฐานข้อมูล รูปประกาศ และเอกสาร</li></ul>
        <p className="muted small">ชื่อผู้ให้บริการแต่ละรายต้องระบุที่นี่เมื่อทำสัญญาแล้ว</p>
      </S>
      <S n={5} title="ระยะเวลาเก็บรักษา">
        <ul><li>ข้อมูลบัญชีและประกาศ: ตลอดเวลาที่บัญชียังใช้งานอยู่</li>
          <li>รหัสยืนยันและเซสชันที่หมดอายุ: ลบเป็นประจำทุกวัน</li>
          <li>บันทึกการทำรายการและประวัติการชำระเงิน: เท่าที่กฎหมายกำหนดหรือจำเป็นต่อการระงับข้อพิพาท</li></ul>
      </S>
      <S n={6} title="ความปลอดภัย">
        <ul><li>รหัสผ่านและรหัสยืนยันเก็บในรูปแบบที่อ่านกลับไม่ได้</li>
          <li>การเชื่อมต่อเข้ารหัสด้วย HTTPS เอกสารส่วนตัวแยกเก็บจากไฟล์สาธารณะ</li>
          <li>จำกัดจำนวนครั้งของการขอและกรอกรหัส และออกจากระบบทุกอุปกรณ์เมื่อเปลี่ยนรหัสผ่าน</li>
          <li>หากเกิดเหตุละเมิดข้อมูลส่วนบุคคล เราจะแจ้งตามที่กฎหมายกำหนด</li></ul>
      </S>
      <S n={7} title="สิทธิของคุณ">
        <p>คุณมีสิทธิขอเข้าถึง ขอสำเนา แก้ไข ลบ ระงับการใช้ คัดค้านการประมวลผล และถอนความยินยอม รวมถึงร้องเรียนต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล แก้ไขข้อมูลส่วนใหญ่ได้เองที่หน้าตั้งค่า ส่วนการขอลบบัญชีหรือขอสำเนาข้อมูลให้ติดต่อเรา</p>
        <p>เว็บไม่ใช้คุกกี้เพื่อการโฆษณาหรือติดตาม เก็บเฉพาะข้อมูลการเข้าสู่ระบบและการตั้งค่าไว้ในเบราว์เซอร์ของคุณ</p>
      </S>
      <S n={8} title="ติดต่อ">
        <p>ผู้ควบคุมข้อมูล: {COMPANY}<br />{CONTACT}</p>
      </S>
    </Page>
  );
}
/* th-only:end */

function TermsEn() {
  return (
    <Page title="Terms of Use">
      <S n={1} title="Introduction">
        <p>{COMPANY} provides a place to advertise property for sale or rent, and a way for interested people to contact the lister. We are not a party, broker or agent in any sale or rental between users. By using the service you accept these terms.</p>
      </S>
      <S n={2} title="Who can use the service">
        <ul><li>You must be of legal age under Thai law, or have the consent of your legal representative.</li>
          <li>A lister must own the property or be authorised by the owner.</li>
          <li>Anyone whose account was terminated for breaking these terms may not register again.</li></ul>
      </S>
      <S n={3} title="Creating an account">
        <ul><li>One account per person. The details you register with must be your own and up to date.</li>
          <li>Keep your password secret. You are responsible for activity on your account.</li>
          <li>Your role (owner, agent or buyer) is chosen at sign-up and cannot be changed later.</li></ul>
      </S>
      <S n={4} title="Email and SMS verification">
        <ul><li>We send a 6-digit one-time code to your email or phone to verify you when you register, sign in or reset your password. The code is valid for 5 minutes.</li>
          <li>Never share the code. Our team will never ask you for it.</li>
          <li>Owners and agents must pass identity verification with documents before publishing their first listing.</li></ul>
      </S>
      <S n={5} title="Responsibility for listings">
        <ul><li>Details, prices and photos must be accurate, current and of the actual property.</li>
          <li>Every listing is reviewed by our team before it goes online. Approval is not a guarantee that the information is correct.</li>
          <li>The “Ownership checked” label means our team reviewed the documents the lister submitted. It is not a guarantee of title. Buyers should check with the Department of Lands before signing a contract.</li>
          <li>Once a property is sold or rented, the lister must close the listing.</li></ul>
      </S>
      <S n={6} title="Payments and refunds">
        <ul><li>Basic listing is free. Paid services always show the price in Thai baht before you confirm.</li>
          <li>Plans renew automatically for the period you chose until cancelled. After cancelling, the plan stays active until the end of the current period.</li>
          <li>Fees already paid are not refunded, unless the law requires otherwise or the charge resulted from a system error.</li></ul>
      </S>
      <S n={7} title="Credits and membership plans">
        <ul><li>Changing plan mid-period starts a new period immediately, with no refund for the old one.</li>
          <li>When you move to a smaller plan, listings beyond the new plan’s limit are paused.</li>
          <li>Credits do not expire, cannot be exchanged for money or transferred, and the ownership check fee is not returned if the documents are not approved.</li></ul>
      </S>
      <S n={8} title="Prohibited content and conduct">
        <ul><li>Duplicate listings, misleading listings, properties that do not exist, or properties already sold or rented.</li>
          <li>Content that is illegal, infringes the rights of others, is obscene or is discriminatory.</li>
          <li>Spam, harassing messages, or using other people’s contact details for anything other than enquiring and negotiating about a listing.</li>
          <li>Reviews not based on real experience, reviews given in exchange for a benefit, or reviews containing abusive language or other people’s personal data.</li>
          <li>Attempting to access the system without permission, or collecting data from the site with automated programs.</li></ul>
      </S>
      <S n={9} title="Suspension and termination">
        <ul><li>We may reject, pause or remove listings, hide reviews, and suspend accounts that break these terms, and we will tell you the reason.</li>
          <li>A suspended account is signed out on all devices and its listings are not shown publicly.</li>
          <li>You can ask us to close your account by contacting us. Fees already paid are not refunded when an account is suspended for breaking these terms.</li></ul>
      </S>
      <S n={10} title="Limitation of liability">
        <p>We do not guarantee the accuracy of listings and reviews posted by users, and we are not liable for loss arising from transactions between users. Always check the property, the title documents and the other party yourself before paying. The service is provided as is and may be interrupted for maintenance.</p>
      </S>
      <S n={11} title="Governing law">
        <p>These terms are governed by Thai law, and disputes fall under the jurisdiction of the Thai courts. We may update these terms and will give notice in the app before changes take effect. Contact us: {CONTACT}</p>
      </S>
    </Page>
  );
}

function PrivacyEn() {
  return (
    <Page title="Privacy Policy">
      <p>{COMPANY} is the data controller under Thailand’s Personal Data Protection Act B.E. 2562 (2019).</p>
      <S n={1} title="Data we collect">
        <ul><li>Account details: name, email, phone number, role, and a one-way hashed password.</li>
          <li>Identity documents and ownership documents you submit for checking.</li>
          <li>Listings, photos, property addresses and the contact details you put on listings.</li>
          <li>Chat messages, viewing requests, reviews, saved listings and saved searches.</li>
          <li>Plan and credit history. We do not store payment card numbers.</li>
          <li>Usage data for security: IP address, browser type, and a log of important actions.</li></ul>
      </S>
      <S n={2} title="Why we collect it">
        <ul><li>To perform the service contract: registration, listing, contact between users, and payment.</li>
          <li>For legitimate interests: reviewing listings, preventing fraud and keeping the system secure.</li>
          <li>With your consent: email notifications, which you can turn off in Settings.</li></ul>
      </S>
      <S n={3} title="How we use data">
        <ul><li>Listing information is public. The lister’s phone number, LINE and email are shown to signed-in users, depending on the lister’s plan.</li>
          <li>When you leave a message or request a viewing, the lister sees your name and message, and may see your phone number and email, depending on the lister’s plan.</li>
          <li>Reviews are public and show the author’s first name.</li>
          <li>Identity and ownership documents can be opened only by the review team, through links that expire after 5 minutes.</li>
          <li>We do not sell personal data or use it for third-party advertising.</li></ul>
      </S>
      <S n={4} title="Third-party processors">
        <ul><li>SMS provider: receives the phone number and the verification code message.</li>
          <li>Email provider: receives the email address, verification code and notification content.</li>
          <li>Payment provider: receives payment details directly from you. We receive only the payment result and a reference code.</li>
          <li>Server and file storage provider: stores the database, listing photos and documents.</li></ul>
        <p className="muted small">The name of each provider must be listed here once contracts are signed.</p>
      </S>
      <S n={5} title="Retention">
        <ul><li>Account and listing data: for as long as the account is active.</li>
          <li>Expired verification codes and sessions: deleted daily.</li>
          <li>Action logs and payment history: as long as the law requires or as needed to resolve disputes.</li></ul>
      </S>
      <S n={6} title="Security">
        <ul><li>Passwords and verification codes are stored in a form that cannot be read back.</li>
          <li>Connections are encrypted with HTTPS. Private documents are stored separately from public files.</li>
          <li>Requests for and attempts at codes are limited, and all devices are signed out when the password changes.</li>
          <li>If a personal data breach occurs, we will give notice as the law requires.</li></ul>
      </S>
      <S n={7} title="Your rights">
        <p>You have the right to access, obtain a copy of, correct, delete, restrict and object to the processing of your data, to withdraw consent, and to complain to the Office of the Personal Data Protection Committee. Most details can be corrected in Settings. To delete your account or request a copy of your data, contact us.</p>
        <p>The site does not use cookies for advertising or tracking. Only your sign-in and settings are kept in your browser.</p>
      </S>
      <S n={8} title="Contact">
        <p>Data controller: {COMPANY}<br />{CONTACT}</p>
      </S>
    </Page>
  );
}

export const Terms = () => (getLang() === 'en' ? <TermsEn /> : <TermsTh />);
export const Privacy = () => (getLang() === 'en' ? <PrivacyEn /> : <PrivacyTh />);
